import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import ListUsers from "./ListUsers.js"
import ViewUser from "./ViewUser.js"
import CreateUser from "./CreateUser.js"
import EditUser from "./EditUser.js"



export default function Users() {

  return (
    <Routes>
        <Route path="/" element={<ListUsers />} />
        <Route path="/view/:id" element={<ViewUser />} />
        <Route path="/edit/:id" element={<EditUser />} />
        <Route path="/create/" element={<CreateUser />} />
    </Routes>        
  )
}


